<template>
  <div class="container">
    <div class="row justify-content-center no-gutters main">
      <div class="col-md-7">
        <img id="logo-orisha" class="d-block"
             src="https://medias.bimedia-it.com/assets/logo_orisha_rs_blanc.svg"/>

        <div class="card card-orisha">
          <div class="card-header">
            <h1 class="text-center my-1 col-10 mx-auto title-balanced">
              Veuillez vous identifier pour continuer.
            </h1>
          </div>

          <div class="card-body">
            <OAuthLoginForm :oauth-params="oauthParams" :error="errorParam"/>
          </div>

          <div class="row justify-content-center my-1 mx-auto col-11">
            <div class="col-12 col-sm-6 mb-3">
              <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                      @click="showRecovery" style="margin-bottom: 5px">
                Mot de passe oublié ?
              </button>
            </div>
            <div class="col-12 col-sm-6 mb-3">
              <button type="button"
                      class="btn btn-outline-light btn-sm btn-block bg-grey"
                      @click="showRegister">
                Créer mon compte
              </button>
            </div>
          </div>

          <div class="row justify-content-center my-4 mx-auto col-11">
            <div class="col-12">
              <button type="button" class="btn btn-outline-light btn-sm btn-block bg-grey"
                      @click="goBack">
                ← Retour
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import OAuthLoginForm from '../components/form/OAuthLoginForm.vue';

export default {
  name: 'OAuthLogin',
  data() {
    return {
      oauthParams: {
        response_type: this.$route.query.response_type,
        client_id: this.$route.query.client_id,
        redirect_uri: this.$route.query.redirect_uri,
        state: this.$route.query.state,
      },
      errorParam: this.$route.query.error,
    };
  },
  methods: {
    oauthFlowQuery() {
      return {
        ...this.$route.query,
        oauth: '1',
      };
    },
    showRecovery() {
      this.$router.push({
        path: '/edit',
        query: this.oauthFlowQuery(),
      });
    },
    showRegister() {
      this.$router.push({
        path: '/create',
        query: this.oauthFlowQuery(),
      });
    },
    goBack() {
      this.$router.go(-1);
    },
  },
  components: {
    OAuthLoginForm,
  },
};
</script>

<style scoped>
</style>
